(function () {
  // if Sentry is blocked (adblock) or not loaded, don't break the site
  if (!window.Sentry) return;

  window.Sentry.init({
    dsn: "https://738e38a8f7f29e76c2c588022d32085d@o4510642650415104.ingest.us.sentry.io/4510912465993729",
    release: "theme-live-feb-06",
    tracesSampleRate: 0,

    ignoreErrors: [
      // ResizeObserver errors (harmless, browser quirk)
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",

      // Generic non-actionable errors
      "Non-Error promise rejection captured",
      "Script error.",

      // JSON/parsing errors (usually from blocked resources returning HTML)
      "Unexpected token '<'",
      /Unexpected token\s*['"]?<['"]?/i,
      "Failed to execute 'json' on 'Response'",
      /is not valid JSON/i,

      // Network errors
      /Failed to fetch/i,
      /Load failed/i,
      /NetworkError when attempting to fetch resource/i,
      /The network connection was lost/i,
      /The Internet connection appears to be offline/i,
      /Network request failed/i,

      // Abort errors
      /AbortError/i,
      "The user aborted a request",
      "Request aborted",
      "cancelled",

      // Permission/security errors
      /NotAllowedError/i,
      /SecurityError/i,

      // Chunk loading errors (code splitting failures)
      /ChunkLoadError/i,
      /Loading chunk/i,
      /Loading CSS chunk/i,

      // Third-party/external service errors
      /amazonaws\.com/i,
      /heatmap/i,
      /jsstore/i,
      /onetext\.com/i,

      // Web Worker importScripts failures (Shopify web-pixels, etc.)
      /Failed to execute 'importScripts' on 'WorkerGlobalScope'/i,
      /Uncaught NetworkError: Failed to execute 'importScripts' on 'WorkerGlobalScope'/i,
      /\/web-pixels\/strict\/app\/web-pixel-\d+@[\w-]+\.js/i,
      /\/web-pixels\/strict\/app\/web-pixel-/i,

      // Generic object promise rejections
      /Object captured as promise rejection with keys:/i,

      // Minified code errors (non-actionable without source maps)
      /undefined is not an object \(evaluating 'b\.length'\)/i,
      /Importing a module script failed/i,
      /The string did not match the expected pattern/i,
      /heatmap-project-2022\.s3\.us-west-2\.amazonaws\.com/i,
      /undefined is not an object \(evaluating 'g\.config\.T\.clickId'\)/i,

      // Browser extension errors
      /Could not establish connection\. Receiving end does not exist\./i,

      // Heatmap websocket
      /ws\.heatmap\.com/i,
      /c\.heatmap\.com/i,

      // ErrorEvent wrapper
      /ErrorEvent.*Script error\./i,

      // iOS WebKit messageHandlers (Safari/WKWebView)
      /undefined is not an object \(evaluating 'window\.webkit\.messageHandlers'\)/i,
      /undefined is not an object \(evaluating 'window\.webkit\.messageHandlers\[.*\]\.postMessage'\)/i,

      // Pinterest tracking
      /ct\.pinterest\.com/i,

      // Syntax errors
      /Unexpected token\s*:/i,
      /Unexpected token\s*=/i,
      /Unexpected token '='/i,
      /Unexpected token ':'/i,

      // Empty TypeError
      /^TypeError:\s*$/i,
      /^TypeError$/,

      // ProgressEvent errors
      /ProgressEvent.*captured as promise rejection/i,

      // Shopify shop_events_listener
      /shop_events_listener/i,
      /storefront\/assets\/shop_events_listener/i,

      // Judge.me (jdgm) errors
      /jdgm\.triggerVanillaEvent is not a function/i,
      /jdgm\.\$ is not a function/i,
      /jdgm\._addEmptyPreviewBadge is not a function/i,
      /jdgm\.eachRevWidgets is not a function/i,
      /jdgm\.\w+ is (not a function|undefined)/i,

      // Proxy javaEnabled error (fingerprinting scripts)
      /property 'javaEnabled' is a read-only and non-configurable data property/i,

      // Invalid selector errors
      /is not a valid selector/i,

      // Browser extension runtime errors
      /Invalid call to runtime\.sendMessage\(\)\. Tab not found\./i,

      // IndexedDB errors
      /Failed to execute 'transaction' on 'IDBDatabase': One of the specified object stores was not found\./i,
      /Recording client not connected, cannot process queue/i,
      /Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing\./i,
      /Failed to execute 'index' on 'IDBObjectStore': The specified index was not found\./i,

      // OneText load failures
      /Load failed.*onetext\.com/i,

      // Dynamic module import failures (Elevar, etc.)
      /Failed to fetch dynamically imported module/i,
      /\/a\/elevar\/static\/configs\//i,

      // MagnificPopup errors
      /null is not an object \(evaluating 'e\.magnificPopup\.instance\.currItem\.el'\)/i,

      // Script parsing errors
      /Unexpected end of script/i,

      // TrueSeaMoss specific fetch failures
      /Failed to fetch.*trueseamoss\.com/i,
      /trueseamoss\.com/i,

      // OpenTelemetry errors (server-side issues, not actionable)
      /OpenTelemetryClientError/i,
      /Server responded with 500/i,

      // ES Module import resolution errors
      /Importing binding name 'default' cannot be resolved by star export entries/i,

      // Invalid origin errors (CORS/iframe issues)
      /invalid origin/i,

      // Minified function call errors
      /\w+\[\w+\([^\)]*\)\] is not a function/i,
      /r\[t\([^\)]*\)\] is not a function/i,

      // Shopify theme embed errors
      /Cannot read properties of undefined \(reading 'script_src_app_theme_embed'\)/i,

      // clickId tracking errors (various formats)
      /Cannot read properties of undefined \(reading 'clickId'\)/i,
      /reading 'clickId'/i,

      // DOM manipulation errors on null elements
      /null is not an object \(evaluating 'document\.getElementById.*\.appendChild'\)/i,
      /Cannot read properties of null \(reading 'appendChild'\)/i,
      /Cannot read properties of null \(reading 'el'\)/i,

      // Microsoft Bing UET tag not loaded
      /UET is not defined/i,

      // Shoplift A/B testing errors
      /Error sending shoplift request/i,

      // Generic 'length' on undefined (often from third-party scripts)
      /Cannot read properties of undefined \(reading 'length'\)/i,

      // ========== NEW ERRORS ADDED ==========

      // replaceAll not supported in older browsers
      /\.replaceAll is not a function/i,
      /o\.replaceAll is not a function/i,

      // Generic short error "od"
      /^od$/i,
      "od",

      // .at() method not supported in older browsers (ES2022)
      /\.at is not a function/i,
      /\.at\([^)]*\).*is undefined/i,
      /i\.split\("="\)\.at is not a function/i,
      /t\.entries\.at is not a function/i,

      // Object.hasOwn not supported in older browsers
      /Object\.hasOwn is not a function/i,

      // Minified obfuscated code errors
      /undefined is not an object \(evaluating 'r\[n\(\d+\)\]/i,

      // Java bridge / Android WebView errors
      /Error invoking postMessage: Java object is gone/i,
      /Java object is gone/i,

      // jQuery not loaded
      /Can't find variable: jQuery/i,
      /jQuery is not defined/i,
      /\$ is not defined/i,

      // Failed to fetch for specific domains
      /Failed to fetch.*google\.com/i,
      /Failed to fetch.*analytics\.google\.com/i,
      /Failed to fetch.*www\.google\.com/i,
      /Failed to fetch.*pro\.ip-api\.com/i,
      /pro\.ip-api\.com/i,

      // simplifyDomain errors (third-party tracking)
      /simplifyDomain is not a function/i,
      /q\.simplifyDomain is not a function/i,

      // Unhandled promise rejections with specific keys
      /Object captured as promise rejection with keys:.*response.*status/i,
      /Object captured as promise rejection with keys:.*activeModal.*botId/i,
      /Object captured as promise rejection with keys:.*botId/i,

      // Attempting to change unconfigurable property setter
      /Attempting to change the setter of an unconfigurable property/i,

      // Google Tag Manager not loaded
      /Can't find variable: google_tag_manager/i,
      /google_tag_manager is not defined/i,

      // Generic apply errors on undefined
      /undefined is not an object \(evaluating '.*\.apply'\)/i,
      /undefined is not an object \(evaluating 'o\.apply'\)/i,

      // Shopify shop-js module errors
      /shop-js\/modules/i,
      /client\.init-shop-cart-sync/i,
    ],

    denyUrls: [
      // Browser extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
      /^webkit-masked-url:\/\//i,

      // AWS S3 / external storage
      /\.amazonaws\.com/i,
      /s3[-.].*\.amazonaws\.com/i,

      // Third-party services
      /onetext\.com/i,

      // Common third-party scripts
      /google-analytics\.com/i,
      /googletagmanager\.com/i,
      /doubleclick\.net/i,
      /facebook\.net/i,
      /connect\.facebook\.net/i,
      /hotjar\.com/i,
      /clarity\.ms/i,

      // Shopify web-pixels
      /\/web-pixels\/strict\/app\/web-pixel-/i,

      // Heatmap
      /ws\.heatmap\.com/i,
      /c\.heatmap\.com/i,
      /heatmap-project-2022\.s3\.us-west-2\.amazonaws\.com/i,

      // Pinterest
      /ct\.pinterest\.com/i,

      // Elevar
      /\/a\/elevar\/static\/configs\//i,

      // Shoplift
      /shoplift/i,

      // Microsoft Bing UET
      /bat\.bing\.com/i,

      // IP API services
      /pro\.ip-api\.com/i,
      /ip-api\.com/i,

      // Google services
      /analytics\.google\.com/i,
    ],

    beforeSend(event, hint) {
      const msg =
        event?.message ||
        event?.exception?.values?.[0]?.value ||
        "";

      const type = event?.exception?.values?.[0]?.type || "";
      const full = `${type}: ${msg}`;
      const url = event?.request?.url || "";

      // Get stack trace URLs for filtering
      const stackUrls = (event?.exception?.values?.[0]?.stacktrace?.frames || [])
        .map(frame => frame?.filename || "")
        .join(" ");

      // Filter third-party noise by URL
      const thirdPartyNoise = [
        /google-analytics\.com/i,
        /googletagmanager\.com/i,
        /doubleclick\.net/i,
        /facebook\.net/i,
        /connect\.facebook\.net/i,
        /hotjar\.com/i,
        /clarity\.ms/i,
        /amazonaws\.com/i,
        /onetext\.com/i,
        /\/web-pixels\/strict\/app\/web-pixel-/i,
        /ws\.heatmap\.com/i,
        /c\.heatmap\.com/i,
        /ct\.pinterest\.com/i,
        /\/a\/elevar\/static\/configs\//i,
        /shoplift/i,
        /bat\.bing\.com/i,
        /pro\.ip-api\.com/i,
        /ip-api\.com/i,
        /analytics\.google\.com/i,
      ];

      if (thirdPartyNoise.some((re) => re.test(url))) return null;
      if (thirdPartyNoise.some((re) => re.test(stackUrls))) return null;

      // Filter blocked by client (ad blockers)
      if (/blocked by client/i.test(msg)) return null;

      // Filter script errors with no useful info
      if (msg === "Script error." || full === ": Script error.") return null;

      // Filter generic empty TypeError
      if (type === "TypeError" && (!msg || msg.trim() === "")) return null;

      // Filter network/load errors
      if (/TypeError:\s*(Load failed|Failed to fetch)/i.test(full)) return null;
      if (/Load failed/i.test(msg)) return null;
      if (/Failed to fetch/i.test(msg)) return null;

      // Filter importScripts errors (web workers)
      if (/importScripts/i.test(msg) && /WorkerGlobalScope/i.test(msg)) return null;
      if (/\/web-pixels\/strict\/app\/web-pixel-/i.test(msg)) return null;

      // Filter syntax errors from blocked resources returning HTML
      if (
        /SyntaxError/i.test(type) &&
        (
          /Unexpected token\s*['"]?<['"]?/i.test(msg) ||
          /is not valid JSON/i.test(msg) ||
          /Failed to execute 'json' on 'Response'/i.test(msg)
        )
      ) return null;

      // Filter "The string did not match the expected pattern" SyntaxError
      if (/SyntaxError/i.test(type) && /The string did not match the expected pattern/i.test(msg)) return null;

      // Filter "Unexpected token :" and "Unexpected token =" SyntaxError
      if (/SyntaxError/i.test(type) && /Unexpected token\s*[:=]/i.test(msg)) return null;

      // Filter "Unexpected end of script" SyntaxError
      if (/SyntaxError/i.test(type) && /Unexpected end of script/i.test(msg)) return null;

      // Filter invalid selector SyntaxError
      if (/SyntaxError/i.test(type) && /is not a valid selector/i.test(msg)) return null;

      // Filter ES Module resolution errors
      if (/SyntaxError/i.test(type) && /Importing binding name.*cannot be resolved by star export entries/i.test(msg)) return null;

      // Filter AWS/S3 and third-party service errors
      if (/amazonaws\.com/i.test(msg) || /amazonaws\.com/i.test(full)) return null;
      if (/heatmap/i.test(msg) || /jsstore/i.test(msg)) return null;
      if (/onetext\.com/i.test(msg) || /onetext\.com/i.test(full)) return null;

      // Filter Pinterest tracking errors
      if (/ct\.pinterest\.com/i.test(msg) || /ct\.pinterest\.com/i.test(full)) return null;

      // Filter Elevar config errors
      if (/\/a\/elevar\/static\/configs\//i.test(msg) || /Failed to fetch dynamically imported module/i.test(msg)) return null;

      // Filter shop_events_listener errors
      if (/shop_events_listener/i.test(msg)) return null;

      // Filter browser extension connection errors
      if (/Could not establish connection\. Receiving end does not exist\./i.test(msg)) return null;
      if (/Invalid call to runtime\.sendMessage\(\)\. Tab not found\./i.test(msg)) return null;

      // Filter IndexedDB errors
      if (/Failed to execute 'transaction' on 'IDBDatabase'/i.test(msg)) return null;
      if (/Failed to execute 'index' on 'IDBObjectStore'/i.test(msg)) return null;

      // Filter Judge.me (jdgm) errors
      if (/jdgm\./i.test(msg) && /(is not a function|is undefined)/i.test(msg)) return null;

      // Filter javaEnabled proxy error
      if (/property 'javaEnabled' is a read-only and non-configurable data property/i.test(msg)) return null;

      // Filter MagnificPopup errors
      if (/magnificPopup\.instance\.currItem\.el/i.test(msg)) return null;

      // Filter AbortError
      if (/AbortError/i.test(type) || /AbortError/i.test(msg)) return null;

      // Filter OpenTelemetry errors
      if (/OpenTelemetryClientError/i.test(type)) return null;
      if (/Server responded with 500/i.test(msg)) return null;

      // Filter invalid origin
      if (/invalid origin/i.test(msg)) return null;

      // Filter UET (Bing tracking) errors
      if (/UET is not defined/i.test(msg)) return null;

      // Filter Shoplift errors
      if (/Error sending shoplift request/i.test(msg)) return null;
      if (/shoplift/i.test(msg)) return null;

      // Filter script_src_app_theme_embed errors
      if (/script_src_app_theme_embed/i.test(msg)) return null;

      // Filter generic 'length' undefined errors
      if (/Cannot read properties of undefined \(reading 'length'\)/i.test(msg)) return null;

      // Filter clickId errors
      if (/reading 'clickId'/i.test(msg)) return null;

      // Filter minified function call errors
      if (/\w+\[\w+\([^\)]*\)\] is not a function/i.test(msg)) return null;

      // Filter Recording client errors
      if (/Recording client not connected/i.test(msg)) return null;

      // Filter DOM appendChild on null errors
      if (/getElementById.*appendChild/i.test(msg)) return null;
      if (/null is not an object.*appendChild/i.test(msg)) return null;

      // ========== NEW FILTERS ADDED ==========

      // Module script import failures
      if (/TypeError/i.test(type) && /Importing a module script failed/i.test(msg)) return null;

      // replaceAll not a function (older browsers)
      if (/\.replaceAll is not a function/i.test(msg)) return null;

      // Generic short error "od"
      if (msg === "od" || full === "Error: od") return null;

      // .at() method not supported (older browsers)
      if (/\.at is not a function/i.test(msg)) return null;
      if (/\.at\([^)]*\).*is undefined/i.test(msg)) return null;

      // Object.hasOwn not supported
      if (/Object\.hasOwn is not a function/i.test(msg)) return null;

      // Obfuscated code errors
      if (/undefined is not an object \(evaluating 'r\[n\(/i.test(msg)) return null;

      // Java bridge / Android WebView errors
      if (/Java object is gone/i.test(msg)) return null;
      if (/Error invoking postMessage/i.test(msg)) return null;

      // WebKit messageHandlers errors
      if (/webkit\.messageHandlers/i.test(msg)) return null;

      // jQuery not loaded errors
      if (/Can't find variable: jQuery/i.test(msg)) return null;
      if (/jQuery is not defined/i.test(msg)) return null;
      if (/ReferenceError/i.test(type) && /\$ is not defined/i.test(msg)) return null;

      // Failed to fetch for specific domains
      if (/Failed to fetch/i.test(msg) && /heatmap\.com/i.test(full)) return null;
      if (/Failed to fetch/i.test(msg) && /google\.com/i.test(full)) return null;
      if (/Failed to fetch/i.test(msg) && /ip-api\.com/i.test(full)) return null;

      // null reading 'el'
      if (/Cannot read properties of null \(reading 'el'\)/i.test(msg)) return null;

      // simplifyDomain errors
      if (/simplifyDomain is not a function/i.test(msg)) return null;

      // Object captured as promise rejection with specific keys
      if (/Object captured as promise rejection with keys:/i.test(msg)) return null;

      // Unconfigurable property setter
      if (/Attempting to change the setter of an unconfigurable property/i.test(msg)) return null;

      // Google Tag Manager not loaded
      if (/Can't find variable: google_tag_manager/i.test(msg)) return null;
      if (/google_tag_manager is not defined/i.test(msg)) return null;

      // Generic apply on undefined
      if (/undefined is not an object.*\.apply/i.test(msg)) return null;

      // Shopify shop-js module errors
      if (/shop-js\/modules/i.test(msg)) return null;
      if (/client\.init-shop-cart-sync/i.test(msg)) return null;

      // Filter trueseamoss.com errors
      if (/trueseamoss\.com/i.test(msg)) return null;

      // Filter ip-api errors
      if (/ip-api\.com/i.test(msg)) return null;

      return event;
    },
  });
})();